'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _keyDownViewHelper = [{
  prev: false,
  next: true,
  exit: true,
  unit: 'day',
  upDown: 7
}, {
  prev: true,
  next: true,
  unit: 'months',
  upDown: 3
}, {
  prev: true,
  next: false,
  unit: 'years',
  upDown: 3
}];

var KEYS = {
  backspace: 8,
  tab: 9,
  enter: 13,
  esc: 27,
  left: 37,
  up: 38,
  right: 39,
  down: 40
};

exports.default = {
  keyDownActions: function keyDownActions(code) {
    var _viewHelper = _keyDownViewHelper[this.state.currentView];
    var unit = _viewHelper.unit;
    var currentDate = this.state.date || (0, _moment2.default)().startOf('day');

    switch (code) {
      case KEYS.left:
        this.setInternalDate(currentDate.subtract(1, unit));
        break;
      case KEYS.right:
        this.setInternalDate(currentDate.add(1, unit));
        break;
      case KEYS.up:
        this.setInternalDate(currentDate.subtract(_viewHelper.upDown, unit));
        break;
      case KEYS.down:
        this.setInternalDate(currentDate.add(_viewHelper.upDown, unit));
        break;
      case KEYS.enter:
        if (_viewHelper.prev) {
          this.prevView(currentDate);
        }
        if (_viewHelper.exit) {
          this.setInputDate(currentDate);
          this.setVisibility(false);
        }
        break;
      case KEYS.esc:
        this.setVisibility(false);
        break;
      case KEYS.tab:
        this.props.hideOnBlur && this.setVisibility(false);
        break;
      default:
        break;
    }
  },
  checkForMobile: function checkForMobile(hideTouchKeyboard) {
    var readOnly = false;
    // do not break server side rendering:
    try {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        readOnly = true;
      }
    } catch (e) {
      console.warn(e); //eslint-disable-line
    }
    return readOnly;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/react-input-calendar/dist/util.js
// module id = 1245
// module chunks = 3